import React from 'react'
import PropTypes from 'prop-types'
import { dimensions, spacing, position, layout } from 'ui-box'
import { withTheme, Pane, Text } from 'evergreen-ui'

class StatusHint extends React.PureComponent {
  static propTypes = {
    /**
     * Composes some specs from the Box primitivie.
     */
    ...dimensions.propTypes,
    ...spacing.propTypes,
    ...position.propTypes,
    ...layout.propTypes,

    /**
     * The label of the status hint.
     */
    children: PropTypes.node,

    /**
     * When true, the status hint is disabled.
     */
    isDisabled: PropTypes.bool,

    /**
     * The intent of the status hint.
     */
    intent: PropTypes.oneOf(['none', 'success', 'warning', 'danger'])
      .isRequired,

    /**
     * Theme provided by ThemeProvider.
     */
    theme: PropTypes.object.isRequired
  }

  static defaultProps = {
    intent: 'none'
  }

  getDotColor = () => {
    const { isDisabled, intent, theme } = this.props

    if (isDisabled) return theme.scales.neutral.N5A
    if (intent === 'success') return theme.colors.intent.success
    if (intent === 'warning') return theme.colors.intent.warning
    if (intent === 'danger') return theme.colors.intent.danger
    if (intent === 'none') return theme.colors.intent.none
    return theme.colors.intent.none
  }

  render() {
    const { children, isDisabled, intent, theme, ...props } = this.props
    const dotColor = this.getDotColor()

    return (
      <Text display="inline-flex" alignItems="center" {...props}>
        <Pane
          flexShrink={0}
          marginRight={8}
          borderRadius="50%"
          height={6}
          width={6}
          background={dotColor}
        />
        {children}
      </Text>
    )
  }
}

export default withTheme(StatusHint)
